import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import Works from "../pages/works/page";
import Company from "../pages/company/page";
import Recruit from "../pages/recruit/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/works",
    element: <Works />,
  },
  {
    path: "/company",
    element: <Company />,
  },
  {
    path: "/recruit",
    element: <Recruit />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
